"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.default = void 0;

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reselect = require("reselect");

var _injectSaga = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/injectSaga"));

var _injectReducer = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/injectReducer"));

var _baseLayout = require("../base-layout.actions");

var _baseLayout2 = require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.constants");

var _baseLayout3 = require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.selectors");

var _baseLayout4 = _interopRequireDefault(require("../base-layout.saga"));

var _baseLayout5 = _interopRequireDefault(require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.reducer"));

var _SetLocation = _interopRequireDefault(require("./SetLocation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPersonPysicalSiteClaims: (0, _baseLayout.dispatchService)(dispatch, "getPersonPysicalSiteClaims"),
    setClaimLocation: function setClaimLocation(claimLocation) {
      return dispatch((0, _baseLayout.commonServiceSuccess)({
        rdsLocation: claimLocation
      }));
    },
    selectingPersonDetail: (0, _baseLayout.dispatchService)(dispatch, "selectingPersonDetail")
  };
};

exports.mapDispatchToProps = mapDispatchToProps;
var mapStateToProps = (0, _reselect.createStructuredSelector)({
  physicalSiteClaims: (0, _baseLayout3.makeSelect)("physicalSiteClaims"),
  rdsLocation: (0, _baseLayout3.makeSelect)("rdsLocation"),
  loading: (0, _baseLayout3.makeSelect)("selectingPersonDetail")
});
var withConnect = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);
var withReducer = (0, _injectReducer.default)({
  key: _baseLayout2.key,
  reducer: _baseLayout5.default
});
var withSaga = (0, _injectSaga.default)({
  key: _baseLayout2.key,
  saga: _baseLayout4.default
});

var _default = (0, _redux.compose)(withReducer, withSaga, withConnect)(_SetLocation.default);

exports.default = _default;